import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Provider from 'components/Provider'
import { GlobalStyle } from './GlobalStyle'
import ModalSystem from 'components/ModalSystem'
import ConfettiSystem from 'components/ConfettiSystem'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider>
      <GlobalStyle />
      <ModalSystem />
      <ConfettiSystem />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
